import { DeleteRounded } from "@mui/icons-material";
import { Avatar, Chip, IconButton } from "@mui/material";
import React, { useContext } from "react";
import { CartContext } from "../../POS";

const CustomerDetails = ({ customer, disableDelete }) => {
  const { setCartData } = useContext(CartContext);

  const handleDelete = () => {
    setCartData((j) => ({ ...j, customerId: "", customer: "" }));
  };

  return customer && customer.id ? (
    <div className="flex flex-wrap gap-3 items-center justify-between p-[10px]">
      <div className="flex gap-3">
        <Avatar
          className="bg-primary !rounded-[10px] !w-[50px] !h-[50px]"
          variant="rounded"
          src={customer.photo}
        >
          <span className="uppercase tracking-wider">
            {`${customer.firstName} ${customer.lastName}`.substring(0, 2)}
          </span>
        </Avatar>

        <div className="grid gap-[1px]">
          <div className="flex gap-1">
            <span className="font-bold text-gray-500 tracking-wider">
              {`${customer.firstName} ${customer.lastName}`}
            </span>
            {customer.cstmrGroup && (
              <Chip
                className="text-[12px] font-medium !text-primary uppercase"
                label={customer.cstmrGroup.name}
                size="small"
              />
            )}
          </div>

          <div className="flex gap-1 font-bolder text-gray-500 text-[12px]">
            <span>{customer.cstmrCode}</span>{" "}
            {customer.phone && (
              <>
                | <span>{customer.phone}</span>
              </>
            )}
          </div>
        </div>
      </div>
      {!disableDelete && (
        <div>
          <IconButton onClick={handleDelete} color="error" size="small">
            <DeleteRounded />
          </IconButton>
        </div>
      )}
    </div>
  ) : (
    "Loading..."
  );
};

export default CustomerDetails;
